import Spinner from './Spinner'

interface BootSequenceProps {
  done: boolean
}

export default function BootSequence({ done }: BootSequenceProps) {
  const label = done ? 'daystrom online.' : 'booting daystrom mainframe'

  return (
    <output
      aria-label={done ? 'Daystrom online' : 'Daystrom booting'}
      className="inline-flex w-fit items-baseline gap-1.5 rounded-md bg-foreground/[0.03] px-2.5 py-1 font-mono text-[11px] leading-snug text-blue-6"
    >
      <span className="text-foreground/40">$</span>
      <span>{label}</span>
      {done ? (
        <span className="text-emerald-600">✓</span>
      ) : (
        <Spinner className="tabular-nums text-blue-6" />
      )}
    </output>
  )
}
